(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Carbon-Quality-Videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('carbon-quality-video')) return;
  class CarbonQualityVideo extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-motion-label]');
      this.status = this.querySelector('[role="status"]');
      if (!this.video || !this.video.dataset.src) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.visible = false;
      this.userPaused = false;
      this.manual = false;
      this.video.muted = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        if (!this.video.paused) {
          this.userPaused = true;
          this.video.pause();
        } else {
          this.userPaused = false;
          this.manual = true;
          this.attachSource();
          this.play();
        }
      }, options);
      this.video.addEventListener('play', () => {
        // Pause a delayed play event if the page has already left the viewport.
        if ((!this.visible && !this.manual) || document.hidden || this.userPaused) {
          this.video.pause();
          return;
        }
        this.setButton(true);
      },options);
      this.video.addEventListener('pause', () => this.setButton(false),options);
      this.video.addEventListener('error', () => {
        this.status.textContent = 'Background video is unavailable. Quality information is still shown.';
        this.button.hidden = true;
      },options);
      document.addEventListener('visibilitychange', () => this.sync(),options);
      this.preferenceChange = () => {
        this.manual = false;
        this.sync();
      };
      this.motion.addEventListener('change', this.preferenceChange,options);
      this.connection?.addEventListener('change', this.preferenceChange,options);
      if (this.video.dataset.poster) {
        // The poster is optional and only requested when this panel approaches view.
        this.posterPending = true;
      }
      if ('IntersectionObserver' in window) {
        this.prepareObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.attachPoster();
          if (this.autoAllowed()) this.attachSource();
          this.prepareObserver.disconnect();
        },{rootMargin:'200px 0px',threshold:0});
        this.prepareObserver.observe(this);
        this.visibleObserver = new IntersectionObserver(entries => {
          for (const entry of entries) {
            this.visible = entry.isIntersecting && entry.intersectionRatio >= .1;
            // A manual start honors reduced-motion, but never keeps playing offscreen.
            if (!this.visible) this.manual = false;
            this.sync();
          }
        },{threshold:[0,.1]});
        this.visibleObserver.observe(this);
      } else {
        // Older browsers get an explicit play button instead of eager autoplay.
        this.attachPoster();
      }
    }
    disconnectedCallback() {
      this.connected = false;
      this.abort?.abort();
      this.prepareObserver?.disconnect();
      this.visibleObserver?.disconnect();
      this.video?.pause();
      // Release the media resource when Shopify removes/reloads the section.
      if (this.video?.hasAttribute('src')) {
        this.video.removeAttribute('src');
        this.video.load();
      }
    }
    autoAllowed() { return !this.motion.matches && !this.connection?.saveData; }
    attachPoster() {
      if (this.posterPending) {
        this.video.poster = this.video.dataset.poster;
        this.posterPending = false;
      }
    }
    attachSource() {
      if (!this.video.hasAttribute('src')) {
        this.video.src = this.video.dataset.src;
        // preload="none" stays in place: playback, not proximity, requests the video.
      }
    }
    setButton(playing) {
      this.label.textContent = playing ? 'Pause video' : 'Play video';
      this.button.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' background video: ' + this.button.dataset.title);
    }
    sync() {
      if (!this.visible || document.hidden || this.userPaused || (!this.autoAllowed() && !this.manual)) {
        this.video.pause();
        return;
      }
      this.attachSource();
      this.play();
    }
    play() {
      this.video.muted = true;
      const promise = this.video.play();
      if (promise?.catch) promise.catch(() => this.setButton(false));
    }
  }
  customElements.define('carbon-quality-video', CarbonQualityVideo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Custom-Subscription-Widget"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionWidget extends HTMLElement {
    connectedCallback() {
      this.cards = this.querySelectorAll('[data-plan-type]');
      this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
      this.ctaButton = this.querySelector('[data-add-to-cart]');

      for (const card of this.cards) {
        card.addEventListener('click', () => this.#selectPlan(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.#selectPlan(card);
          }
        });
      }

      /* Default to 90-day */
      const defaultCard = this.querySelector('[data-plan-type="90-day"]');
      if (defaultCard) {
        this.#selectPlan(defaultCard);
      }
    }

    #selectPlan(selectedCard) {
      for (const card of this.cards) {
        card.setAttribute('aria-checked', 'false');
        const radio = card.querySelector('.sub-widget__radio');
        if (radio) {
          radio.classList.remove('sub-widget__radio--checked');
        }
      }

      selectedCard.setAttribute('aria-checked', 'true');
      const radio = selectedCard.querySelector('.sub-widget__radio');
      if (radio) {
        radio.classList.add('sub-widget__radio--checked');
      }

      const planId = selectedCard.dataset.sellingPlanId;
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = planId || '';
      }

      /* Dispatch event for the product form */
      this.dispatchEvent(new CustomEvent('subscription:plan-changed', {
        detail: {
          sellingPlanId: planId || null,
          planType: selectedCard.dataset.planType
        },
        bubbles: true
      }));
    }
  }

  if (!customElements.get('subscription-widget')) {
    customElements.define('subscription-widget', SubscriptionWidget);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-landing"] && !Shopify.designMode) return;
  try {
    
  /* ─── SMOOTH SCROLL FOR CTA LINKS ─── */
  /* Handles scrolling to the native Shopify product section */
  document.querySelectorAll('.cl a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href').slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-preworkout-listicle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.getElementById('carbonStickyBar');
    if (!bar) return;
    var shown = false;
    window.addEventListener('scroll', function() {
      var scrolled = window.scrollY || window.pageYOffset;
      if (scrolled > 400 && !shown) {
        bar.classList.add('is-visible');
        shown = true;
      } else if (scrolled <= 400 && shown) {
        bar.classList.remove('is-visible');
        shown = false;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-the-science"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';
  const ingredients = [["250MG", "CAFFEINE", "FAST ENERGY + FOCUS", "Fast energy and focus that lasts 3 to 5 hours."], ["1500MG", "TAURINE", "LOCKED-IN FOCUS + DRIVE", "Locked-in focus and drive."], ["2500MG", "BETAINE", "UP TO 10% MORE STRENGTH", "Up to 10% more strength, and it lasts for hours."], ["200MG", "L-THEANINE", "SMOOTH, CLEAN FOCUS", "Stops the jitters, the anxious feeling, and the crash caffeine can cause. You get smooth, sharp, clean focus instead of feeling wired."], ["100MG", "POTASSIUM CITRATE", "HYDRATION + RECOVERY", "Helps you recover and keeps your muscles hydrated, so you do not slow down partway through your workout. It works with coconut water and Himalayan salt to support skin-splitting pumps."], ["400MG", "PINK HIMALAYAN SALT", "HYDRATION + PUMPS", "Minerals and salts that help you stay hydrated and get skin-splitting pumps by helping pull water into your muscles and support blood volume."], ["500MG", "COCONUT WATER", "ELECTROLYTE SUPPORT", "Minerals and salts that help you stay hydrated and support skin-splitting pumps."], ["5MG", "BLACK PEPPER EXTRACT", "ABSORPTION SUPPORT", "Makes everything else soak in faster by slowing certain enzymes in your gut so you absorb more of the pre-workout."]];
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const formula = root.querySelector('.cs-formula');
    const stage = root.querySelector('.cs-formula__sticky');
    if (!formula || !stage) return;
    const layers = Array.from(root.querySelectorAll('.cs-layer'));
    const left = root.querySelector('.cs-left');
    const right = root.querySelector('.cs-right');
    const mobile = root.querySelector('.cs-mobile-callout');
    const scan = root.querySelector('.cs-scanline');
    const pins = Array.from(root.querySelectorAll('.cs-pin'));
    const counter = root.querySelector('.cs-counter');
    let active = -1, frame = 0, observer = null, resizeObserver = null;
    // Use the same scroll container that CSS sticky uses, including theme wrappers.
    let scroller = null;
    for (let el = formula.parentElement; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      if (/^(auto|scroll|hidden|overlay)$/.test(getComputedStyle(el).overflowY)) { scroller = el; break; }
    }
    function markup(item) {
      return '<div class="cs-callout"><div class="cs-callout__eyebrow">' + item[0] + '</div><h3>' + item[1] + '</h3><h4>' + item[2] + '</h4><p>' + item[3] + '</p></div>';
    }
    function activate(index) {
      if (index === active) return;
      active = index;
      layers.forEach((layer, i) => {
        layer.classList.toggle('is-active', i === index);
        layer.classList.toggle('is-complete', i < index);
      });
      const content = markup(ingredients[index]);
      left.innerHTML = index % 2 === 0 ? content : '';
      right.innerHTML = index % 2 === 0 ? '' : content;
      mobile.innerHTML = content;
      mobile.scrollTop = 0;
      counter.textContent = String(index + 1).padStart(2, '0') + ' / 08';
      pins[0].style.opacity = index % 2 === 0 ? '1' : '0';
      pins[1].style.opacity = index % 2 === 0 ? '0' : '1';
    }
    function update() {
      frame = 0;
      const rect = formula.getBoundingClientRect();
      const top = scroller ? scroller.getBoundingClientRect().top + scroller.clientTop : 0;
      const travel = Math.max(1, formula.offsetHeight - stage.offsetHeight);
      const progress = Math.max(0, Math.min(1, (top - rect.top) / travel));
      activate(Math.min(ingredients.length - 1, Math.floor(progress * ingredients.length)));
      root.style.setProperty('--cs-progress', progress.toFixed(5));
      // Derive positions from the actual highlighted layer, so mobile resizing stays aligned.
      const layerRect = layers[active].getBoundingClientRect();
      const center = layerRect.top + layerRect.height / 2;
      const pack = root.querySelector('.cs-pack-stage').getBoundingClientRect();
      const xray = root.querySelector('.cs-xray-pack');
      scan.style.top = (center - xray.getBoundingClientRect().top - xray.clientTop) + 'px';
      pins.forEach(pin => { pin.style.top = (center - pack.top) + 'px'; });
    }
    function queue() { if (!frame) frame = requestAnimationFrame(update); }
    function measure() {
      const height = Math.max(320, scroller ? scroller.clientHeight : window.innerHeight);
      root.style.setProperty('--cs-stage-height', height + 'px');
      root.style.setProperty('--cs-travel', (Math.max(340, height * 0.7) * ingredients.length) + 'px');
      queue();
    }
    root.classList.add('cs-enhanced');
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
      }, { threshold: 0.08 });
      root.classList.add('cs-observing');
      root.querySelectorAll('.cs-reveal').forEach(el => observer.observe(el));
    }
    // Capture receives scroll events from both the document and nested containers.
    document.addEventListener('scroll', queue, {passive:true, capture:true});
    window.addEventListener('scroll', queue, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    window.addEventListener('pageshow', measure);
    root.addEventListener('load', queue, true);
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(queue);
      resizeObserver.observe(root);
      resizeObserver.observe(stage);
    }
    instances.set(root, () => {
      document.removeEventListener('scroll', queue, true);
      window.removeEventListener('scroll', queue);
      window.removeEventListener('resize', measure);
      window.removeEventListener('pageshow', measure);
      root.removeEventListener('load', queue, true);
      if (frame) cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      instances.delete(root);
    });
    measure();
    update();
  }
  function mount(scope) {
    if (scope.matches && scope.matches('[data-carbon-science]')) init(scope);
    scope.querySelectorAll('[data-carbon-science]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once:true});
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => { if (root === event.target || event.target.contains(root)) destroy(); });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_page_header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function handlePphCtaClick(event) {
      const cta = event.currentTarget;
      const href = cta.getAttribute('href') || '';
      const hashIndex = href.indexOf('#');

      // No anchor in this link at all, e.g. a link straight to /cart.
      // Let the browser handle it normally.
      if (hashIndex === -1) return;

      const targetId = href.slice(hashIndex + 1);

      // Href is just "#" with nothing after it (the unset default value).
      // Treat it as a disabled link rather than jumping to the top of the page.
      if (!targetId) {
        event.preventDefault();
        return;
      }

      // Everything before the "#", with any stray trailing "?" trimmed off,
      // so a link like ".../page?#Target" still compares correctly.
      const pagePart = href.slice(0, hashIndex).replace(/\?$/, '');
      const currentPage = window.location.origin + window.location.pathname;
      const isSamePage = pagePart === '' || pagePart === currentPage;
      const target = document.getElementById(targetId);

      if (isSamePage && target) {
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#' + targetId);
        }
        return;
      }

      // Points to a different page, or the target is not on this page.
      // Fall through and let the browser navigate there as a normal link.
    }

    for (const cta of document.querySelectorAll('.pph__cta')) {
      cta.addEventListener('click', handlePphCtaClick);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-lander"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sticky = document.getElementById('tl-sticky');
    var hero = document.getElementById('tl-hero');
    if (!sticky || !hero) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var heroBottom = hero.getBoundingClientRect().bottom;
          if (heroBottom < 0) {
            sticky.classList.add('tl-sticky--visible');
          } else {
            sticky.classList.remove('tl-sticky--visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tl-visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.tl-fade').forEach(function(el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTrack(track) {
      let ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (maxScroll > 0 && track.scrollLeft >= maxScroll - 2) {
            track.scrollLeft = 0;
          }
          ticking = false;
        });
      }, { passive: true });

      const videos = track.querySelectorAll('.ugc__video');

      if (!('IntersectionObserver' in window)) {
        for (const video of videos) {
          const p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        for (const entry of entries) {
          const video = entry.target;
          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        }
      }, { threshold: 0.6 });

      for (const video of videos) {
        observer.observe(video);
      }
    }

    for (const track of document.querySelectorAll('.ugc__track')) {
      initTrack(track);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
